/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SecurityDashboardViolationsByRegionResponse {
    getFixupPrototypeFunction() { return SecurityDashboardViolationsByRegionResponse.fixupPrototype; }

    static newInstance(model: Partial<SecurityDashboardViolationsByRegionResponse>): SecurityDashboardViolationsByRegionResponse {
        let obj = Object.assign(new SecurityDashboardViolationsByRegionResponse(), model);
        SecurityDashboardViolationsByRegionResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SecurityDashboardViolationsByRegionResponse>): SecurityDashboardViolationsByRegionResponse {
        if (!model) return null;
        return SecurityDashboardViolationsByRegionResponse.newInstance(<SecurityDashboardViolationsByRegionResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SecurityDashboardViolationsByRegionResponse) {
        if (!obj) return;

        models.SecurityDashboardViolationsByRegionResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SecurityDashboardViolationsByRegionResponse): boolean {
        Object.setPrototypeOf(obj, SecurityDashboardViolationsByRegionResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.summary_by_cloudprovider) {
            for (let val of this.summary_by_cloudprovider) {
                models.SecurityDashboardViolationByRegionCount.fixupPrototype(val);
            }
        }
    }

    /**
     * Visibility of the Config Violation by CloudProvider
     */
    summary_by_cloudprovider: Array<models.SecurityDashboardViolationByRegionCount>;

}
